import type { BrandKitLayoutSource, LayoutDefaultsContext, PostLayoutConfig } from './types';
import { POST_LAYOUTS } from './registry';
import { applyBrandKit } from './applyBrandKit';
import { cortesConfigForPreset } from './cortesPresets';
import { resolveCortesPreset } from './resolveCortesPreset';
import { circuloConfigForPreset, resolveCirculoPreset } from './resolveCirculoPreset';

export type PostLayoutSelectOptions = { preset?: string };

export function buildPostLayoutSelection(
  kind: keyof typeof POST_LAYOUTS | 'circulo',
  options: PostLayoutSelectOptions | undefined,
  ctx: LayoutDefaultsContext,
  bk: BrandKitLayoutSource | null,
  previousLayout?: PostLayoutConfig | null,
): PostLayoutConfig {
  if (kind === 'cortes') {
    return applyBrandKit(
      cortesConfigForPreset(resolveCortesPreset({ preset: options?.preset })),
      bk,
    );
  }
  if (kind === 'circulo') {
    const previous = previousLayout?.kind === 'circulo' ? previousLayout : null;
    return applyBrandKit(
      circuloConfigForPreset(resolveCirculoPreset({ preset: options?.preset }), previous),
      bk,
    );
  }
  return POST_LAYOUTS[kind].build(ctx, bk);
}
